/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { setupAxios } from './_metronic';
import ChatSocket from './app/utils/socket';
import store, { persistor } from './app/store/store';
import App from './App';

import './index.scss'; // Standard version

import './_metronic/_assets/plugins/line-awesome/css/line-awesome.css';
import './_metronic/_assets/plugins/flaticon/flaticon.css';
import './_metronic/_assets/plugins/flaticon2/flaticon.css';

import './_metronic/_assets/fonts/SF-Pro-Rounded-Regular.otf'
import './_metronic/_assets/fonts/SF-Pro-Rounded-Bold.otf'
import './_metronic/_assets/fonts/SF-Pro-Rounded-Light.otf'
import './_metronic/_assets/fonts/SF-Pro-Rounded-Medium.otf'
/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
export const { PUBLIC_URL } = process.env;

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
// /* const mock = */ mockAxios(axios);

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios, store, ChatSocket);

ReactDOM.render(
  <App store={store} persistor={persistor} basename={PUBLIC_URL} />,
  document.getElementById('root')
);
